<template>
  <ap-menu
    class="top-2 w-[228px] rounded-xl border-[#DCDCDC] py-4 bg-white shadow-[0_4px_4px_0px_rgba(198, 198, 198, 0.24)] z-50 px-2 workspace--menu">
    <div>
      <p class="text-black/60 text-xs font-semibold leading-[normal] mb-2 ml-3">
        {{ $t("navigation.workspace.member.title") }}
      </p>
    </div>
    <ap-menu-item
      class="!text-[12px] min-h-[48px] !h-12 !my-0.5 leading-[22px] px-3 py-2 font-semibold shadow-none border-0 hover:bg-[#4663C614]"
      v-for="value in workspacesWithPlan"
      :key="value.user.uuid"
      @click="handleChangeWorkspace(value)"
      :class="[
        value.uuid === currentWorkSpaceId
          ? ' bg-[#4663C614] text-primary active'
          : ' hover:text-primary '
      ]">
      <div class="flex items-center justify-between gap-1">
        <ap-avatar
          shape="square"
          :size="24"
          class="text-black/[0.86] text-xs font-bold leading-[normal] rounded bg-black/[0.16]"
          :src="value.logo">
          <span class="uppercase"> {{ value.name[0] }} </span>
        </ap-avatar>

        <span class="flex-1 overflow-hidden text-nowrap text-ellipsis">
          {{ $t("navigation.workspace.member.label", { user_name: getWorkspaceName(value) }) }}
        </span>

        <!--        <ap-tag -->
        <!--          v-if="value.isOwner" -->
        <!--          class="h-4 w-auto m-0 text-[10px] font-medium leading-[normal] text-white bg-black rounded-xl" -->
        <!--          :bordered="false"> -->
        <!--          {{ value.plan }} -->
        <!--        </ap-tag> -->
      </div>
    </ap-menu-item>
  </ap-menu>
</template>

<script setup>
import { useUserAccountsStore } from "@/stores/userAccounts"
import { computed } from "vue"
import ChangeWorkSpace from "@/handlers/RolesAndUsers/ChangeWorkSpace.js"

const userAccountsStore = useUserAccountsStore()
const workspaceName = computed(() => userAccountsStore.workspaceName)
const currentWorkSpaceId = computed(() => userAccountsStore.currentWorkSpace.uuid)
const workspacesWithPlan = computed(() => userAccountsStore.workspaces)

function getWorkspaceName(value) {
  return value.uuid === currentWorkSpaceId.value ? workspaceName.value : value.name
}
function handleChangeWorkspace(value) {
  if (currentWorkSpaceId.value === value.uuid) return
  ChangeWorkSpace.apply(value)
}
</script>

<style lang="postcss">
.workspace--menu {
  .ant-dropdown-menu-title-content {
    @apply w-full;
  }
}
</style>
